"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Typography = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["variant", "align", "lineClamp", "as", "paragraph", "breakWords", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var variantMapping = {
  inherit: 'p',
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  body: 'p',
  'body-semibold': 'p',
  'small-body': 'p',
  'small-body-semibold': 'p'
};
var classes = (0, _classVarianceAuthority.cva)([], {
  variants: {
    variant: {
      inherit: [],
      h1: ['text-3xl', 'lg:text-4xl', 'font-medium'],
      h2: ['text-2xl', 'lg:text-3xl', 'font-medium'],
      h3: ['text-xl', 'font-medium'],
      h4: ['text-lg', 'font-semibold'],
      h5: ['text-base', 'font-semibold'],
      body: ['text-base', 'font-medium'],
      'body-semibold': ['text-base', 'font-semibold'],
      'small-body': ['text-sm', 'font-medium'],
      'small-body-semibold': ['text-sm', 'font-semibold']
    },
    align: {
      inherit: [],
      left: ['text-left'],
      right: ['text-right'],
      justify: ['text-justify'],
      center: ['text-center']
    },
    lineClamp: {
      none: [],
      1: ['line-clamp-1'],
      2: ['line-clamp-2'],
      3: ['line-clamp-3'],
      4: ['line-clamp-4'],
      5: ['line-clamp-5'],
      6: ['line-clamp-6']
    },
    breakWords: {
      "true": ['break-words', 'hyphens-auto'],
      "false": []
    }
  }
});

// https://www.figma.com/file/uOoMv97WUyfY6vRzGau4sw/Design-System?type=design&node-id=4-2&mode=design&t=H1dNVzZyX5YP2pen-0

/**
 * Typography - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/data-display-Typography)
 */
var Typography = exports.Typography = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref2;
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'inherit' : _ref$variant,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'inherit' : _ref$align,
    _ref$lineClamp = _ref.lineClamp,
    lineClamp = _ref$lineClamp === void 0 ? 'none' : _ref$lineClamp,
    _ref$as = _ref.as,
    as = _ref$as === void 0 ? undefined : _ref$as,
    _ref$paragraph = _ref.paragraph,
    paragraph = _ref$paragraph === void 0 ? false : _ref$paragraph,
    _ref$breakWords = _ref.breakWords,
    breakWords = _ref$breakWords === void 0 ? false : _ref$breakWords,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var Component = (_ref2 = as !== null && as !== void 0 ? as : paragraph ? 'p' : variantMapping[variant]) !== null && _ref2 !== void 0 ? _ref2 : 'span';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    className: (0, _helpers.cn)(classes({
      variant: variant,
      align: align,
      lineClamp: lineClamp,
      breakWords: breakWords,
      className: className
    }))
  }));
});